module.exports = __webpack_public_path__ + "static/media/add-interview.d4786853.png";